module.exports = __webpack_public_path__ + "static/media/k5-head-stickers.281dc7dd.jpg";